import { VolumePlusIcon } from './VolumePlusIcon';

/**
 * author: Austin Andrews
 * id DECF3A51-F972-4D34-815D-D103BCE3888B
 * name volume-plus
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volume-plus.svg
 * tags
 * - Audio 
 * - Home Automation 
 * - Cellphone / Phone 
 */
export const VolumeIncreaseIcon = VolumePlusIcon;
export default VolumeIncreaseIcon